import React from "react";
import { FaCog, FaLock, FaRocket, FaComments, FaClock, FaShieldAlt } from "react-icons/fa";

export default function LinuxHostingSection() {
  const features = [
    {
      icon: <FaCog />,
      title: "Control Panel",
      text: "Easily manage your hosting with an intuitive control panel designed for efficiency.",
    },
    {
      icon: <FaLock />,
      title: "Fully Secure",
      text: "Advanced DDoS protection and SSL ensure your data stays safe 24/7.",
    },
    {
      icon: <FaRocket />,
      title: "Email Hosting",
      text: "Reliable email hosting with spam filters, backups, and custom domains.",
    },
    {
      icon: <FaComments />,
      title: "24/7/365 Support",
      text: "Our expert team is always ready to help you — any time, any day.",
    },
    {
      icon: <FaClock />,
      title: "99.9% Uptime",
      text: "Enterprise-grade servers ensure your website is always up and running.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Secure Data",
      text: "Your data is protected by industry-standard encryption and redundancy.",
    },
  ];

  return (
    <section className="relative bg-gradient-to-br from-blue-50 via-white to-blue-100 py-16 overflow-hidden">
      {/* Section Header */}
      <div className="text-center mb-10">
        {/* <p className="text-gray-600 text-lg">You are currently on Linux plans</p> */}
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-2">
          What We Offer
        </h2>
        <div className="w-20 h-1 bg-blue-500 mx-auto mt-4 rounded-full"></div>
      </div>

      {/* Features Grid */}
      <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-6">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white/80 backdrop-blur-md rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 text-center hover:scale-[1.03]"
          >
            <div className="text-blue-600 text-4xl mb-4 bg-blue-100 w-16 h-16 flex items-center justify-center rounded-full mx-auto">
              {feature.icon}
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              {feature.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {feature.text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
